export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=1e0327ba&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/stories/index.vue?vue&type=template&id=1e0327ba&
// module id = 1034
// module chunks = 0